import axios from 'axios';
import { API_ENDPOINTS, API_CONFIG } from '../config/api';

const apiClient = axios.create(API_CONFIG);

apiClient.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const adminAPI = {
  getAdmins: async () => {
    const response = await apiClient.get(API_ENDPOINTS.GET_ADMINS);
    return response.data;
  },

  createAdmin: async (adminData) => {
    const response = await apiClient.post(API_ENDPOINTS.INSERT_ADMIN, adminData);
    return response.data;
  },

  updateAdmin: async (email, adminData) => {
    const response = await apiClient.put(API_ENDPOINTS.UPDATE_ADMIN(email), adminData);
    return response.data;
  },

  deleteAdmin: async (email) => {
    const response = await apiClient.delete(API_ENDPOINTS.DELETE_ADMIN(email));
    return response.data;
  },

  getAdmin: async (email) => {
    const response = await apiClient.get(API_ENDPOINTS.GET_ADMIN(email));
    return response.data;
  },
};

export const meetingsAPI = {
  getMeetings: async () => {
    const response = await apiClient.get(API_ENDPOINTS.GET_MEETINGS);
    return response.data;
  },

  createMeeting: async (meetingData) => {
    const response = await apiClient.post(API_ENDPOINTS.CREATE_MEETING, meetingData);
    return response.data;
  },

  updateMeeting: async (id, meetingData) => {
    const response = await apiClient.put(API_ENDPOINTS.UPDATE_MEETING(id), meetingData);
    return response.data;
  },

  deleteMeeting: async (id) => {
    const response = await apiClient.delete(API_ENDPOINTS.DELETE_MEETING(id));
    return response.data;
  },

  rsvpToMeeting: async (id, rsvpData) => {
    const response = await apiClient.post(API_ENDPOINTS.RSVP_MEETING(id), rsvpData);
    return response.data;
  },

  cancelRSVP: async (id, rsvpData) => {
    const response = await apiClient.post(API_ENDPOINTS.CANCEL_RSVP(id), rsvpData);
    return response.data;
  },
};

export const authAPI = {
  getToken: async () => {
    const response = await apiClient.get(API_ENDPOINTS.GET_TOKEN);
    return response.data;
  },
};

export const api = {
  get: (url, config) => apiClient.get(url, config),
  post: (url, data, config) => apiClient.post(url, data, config),
  put: (url, data, config) => apiClient.put(url, data, config),
  delete: (url, config) => apiClient.delete(url, config),
};

export default apiClient; 